import React, {Suspense, useEffect} from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import App from './App';
import './languages/index';
import { BrowserRouter as Router } from 'react-router-dom';
const loadingMarkup = (
  <div className="py-4 text-center">

  </div>
)

const messagesStack = [];
window.addEventListener('message', (msg) => {
    messagesStack.push(msg);
}, false);

ReactDOM.render(
  <Suspense fallback={loadingMarkup}>
    <Router>
      <App messagesStack={messagesStack}/>
    </Router>
  </Suspense>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
